/*
 * 상품권 카드 색 (8종) — `docs/design/mall-redesign/README.md` §4.
 *
 * 🔴 **API 에는 "카테고리" 필드가 없습니다.** `products.couponType` 은 티켓나라의
 *    발주 유형(`CHOICE` 고정)이지 백화점·문화·도서 같은 분류가 아닙니다
 *    (`docs/received/2026-09-08/티켓나라_쿠폰공급API_연동가이드_v1.1.html`).
 *    그래서 카테고리는 상품 **이름·발행처 이름**에서 짐작합니다 — 실제 상품권
 *    이름에 "문화상품권" · "도서문화상품권" 처럼 분류가 그대로 들어 있습니다.
 *
 * 🔑 **매핑에 없는 이름은 결정적 해시로 8색 중 하나에 떨어집니다** — 새 상품이
 *    추가돼도 카드가 회색으로 비지 않고, 같은 상품은 항상 같은 색을 받습니다.
 */
const KEYWORD_COLORS: readonly [string, string][] = [
  // 순서가 뜻을 가립니다 — "도서문화상품권" 이 "문화" 보다 먼저 "도서" 에 걸려야 합니다.
  ["도서", "#17694b"],
  ["문화", "#5b3fc4"],
  ["백화점", "#2f3a4c"],
  ["편의점", "#1f56b8"],
  ["외식", "#b0511c"],
  ["온라인", "#9c2a66"],
  ["주유", "#0b6b76"],
  ["영화", "#8a2b3d"],
];

/** 매핑에 없는 상품이 떨어질 자리 — 위 색 8종과 같은 목록입니다. */
const FALLBACK_PALETTE = KEYWORD_COLORS.map(([, color]) => color);

/** 문자열을 결정적으로 0..n-1 사이 정수로 접습니다. */
function hashIndex(text: string, modulo: number): number {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
  }
  return hash % modulo;
}

/** 상품권 카드의 색면 색. `name` 을 우선하고 없으면 `brandName` 을 봅니다. */
export function cardColorFor(name: string, brandName?: string | null): string {
  const key = `${name} ${brandName ?? ""}`;
  for (const [keyword, color] of KEYWORD_COLORS) {
    if (key.includes(keyword)) return color;
  }
  return FALLBACK_PALETTE[hashIndex(name || brandName || "", FALLBACK_PALETTE.length)];
}
